// How a banner resource card's tap opens its destination. The backend sends one
// of these as the `linkType` on a BANNER / LEADER_BANNER block; the app branches
// on the three outcomes — external / in-app browser / internal route.
export const LINK_TYPE = Object.freeze({
  EXTERNAL: 'EXTERNAL_URL',
  IN_APP_BROWSER: 'IN_APP_BROWSER',
  INTERNAL: 'INTERNAL_PAGE',
});

// True when the backend named a type we recognise.
//
// Callers need "the author chose this" kept distinct from "nothing was set",
// because the two resolve differently: an explicit type is obeyed as written, an
// absent one is inferred from the URL's shape. Folding both into one default is
// what made a mis-authored banner indistinguishable from an external one — see
// resolveLinkType in @/utils/banner-link.
export function isKnownLinkType(value) {
  return Object.values(LINK_TYPE).includes(value);
}
